var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIrp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.799,
    height: 13.398,
    viewBox: "0 0 11.799 13.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M618.553,428.036v6.158a2.027,2.027,0,0,1-2.009,2.041h-7.781a2.026,2.026,0,0,1-2.01-2.041v-8.1a1.925,1.925,0,0,1,1.914-1.844h.655v-.912a.505.505,0,0,1,1.01,0v.907h4.6v-.906a.505.505,0,0,1,1.01,0v.908h.655a1.931,1.931,0,0,1,1.954,1.848v1.94h0Zm-.874,0H607.63V434.2a1.145,1.145,0,0,0,1.134,1.153h7.781a1.145,1.145,0,0,0,1.134-1.153v-6.161Z",
    transform: "translate(-606.754 -422.837)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.306 6.431)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M617.757,438.846v.653h-2.62v-.653h.927v-2.555q0-.084,0-.171t.01-.177l-.611.508a.327.327,0,0,1-.125.061.287.287,0,0,1-.116,0,.279.279,0,0,1-.1-.039.264.264,0,0,1-.064-.056l-.28-.377,1.435-1.216h.731v4.019Z",
    transform: "translate(-614.783 -434.827)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrp);
export default __webpack_public_path__ + "static/media/irp.e9b122ec.svg";
export { ForwardRef as ReactComponent };